<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" />
    <!-- <back-top v-back-top v-scroll-show:500='isBackShow' :isShow='isBackShow'></back-top> -->
    <back-top></back-top>
  </div>
</template>

<script>
import BackTop from '@/components/common/BackTop.vue';
export default {
  name: 'App',
  data(){
    return {
      //isBackShow: {value: false}
    }
  },
  components: {
    BackTop
  }
}
</script>

<style lang="less">
  @import '../static/css/common.less';
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    //font-family: Helvetica,'PingFangSC','Heiti SC',"Hiragino Sans GB", STXihei, "Microsoft YaHei", Arial, sans-serif;
    min-width: 1200px;
    margin: 0 auto;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue